import { httpApi } from "@nucleus-care/nucleuscare-backend-client";

type AccountFeature = {
  EnablePatientGroups: boolean;
  EnablePostCallNotes: boolean;
  ID: string;
  ok: boolean
  v: number;
}

export const AccountApi = ({
  getFeatures: async ({ accountId }: { accountId: string }) => {
    return httpApi.get<AccountFeature>(`/account/${accountId}/features_config`)
  },
  togglePatientGroups: async ({ accountId, state }: { accountId: string; state: boolean }) => {
    return httpApi.put(`/account/${accountId}/enable-patient-groups`, { enable: state })
  },
  togglePostCallNotes: async ({ accountId, state }: { accountId: string; state: boolean }) => {
    return httpApi.put(`/account/${accountId}/enable-post-call-notes`, { enable: state })
  },
  toggleInCallNotification: async ({ accountId, state }: { accountId: string; state: boolean }) => {
    return httpApi.put(`/account/${accountId}/enable-in-call-notification`, { enable: state })
  }
})